import React from 'react';
import { 
  IonPage, 
  IonHeader, 
  IonToolbar, 
  IonTitle, 
  IonContent, 
  IonGrid, 
  IonRow, 
  IonCol,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardTitle,
  IonButtons,
  IonBackButton
} from '@ionic/react';
import ConceptRenderer from '../components/ConceptRenderer';
import AnimatedSVG from '../components/AnimatedSVG';
import './IllustrationShowcase.css';

const IllustrationShowcase = () => {
  
  // Mock data for testing ConceptRenderer with new assets
  const concepts = [
    {
      title: "Writing Code",
      description: "Code is like a set of instructions you give to the computer. It's written in a specific language that the computer understands.",
      visual: {
        src: "illustrations/writing-code.svg",
        alt: "Writing Code",
        animation: "float"
      },
      keyPoints: [" precise instructions", "specific syntax", "logical flow"]
    },
    {
      title: "Variables",
      description: "Think of a variable as a labeled box where you can store information to use later.",
      visual: {
        src: "concepts/common/variables.svg",
        alt: "Variable Box",
        animation: "pulse"
      },
      comparison: {
        title: "The Box Analogy",
        realWorld: "A moving box labeled 'Kitchen Stuff'",
        code: "variable name = 'Kitchen Stuff'"
      }
    },
    {
      title: "Loops",
      description: "Loops allow you to repeat a block of code multiple times without rewriting it.",
      visual: {
        src: "concepts/common/loops.svg",
        alt: "Loop Track",
        animation: "none" // The SVG has internal animation
      },
      funFact: "Computers can repeat millions of instructions in a second!"
    },
    {
      title: "Functions",
      description: "A function is like a machine that takes input, processes it, and gives back an output.",
      visual: {
        src: "concepts/common/functions.svg",
        alt: "Function Machine",
        animation: "none" // Internal animation
      }
    }
  ];

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton defaultHref="/" />
          </IonButtons>
          <IonTitle>Illustration Showcase</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent className="illustration-showcase-content">
        <div className="showcase-container">
          <h2>New Illustration System</h2>
          <p>Testing the new flat design style and internal animations.</p>

          <h3>Raw Assets</h3>
          <IonGrid>
            <IonRow>
              <IonCol size="12" sizeMd="6">
                <IonCard className="asset-card">
                  <IonCardHeader>
                    <IonCardTitle>Writing Code</IonCardTitle>
                  </IonCardHeader>
                  <IonCardContent className="asset-display">
                    <AnimatedSVG src="illustrations/writing-code.svg" animation="float" />
                  </IonCardContent>
                </IonCard>
              </IonCol>
              
              <IonCol size="12" sizeMd="6">
                <IonCard className="asset-card">
                  <IonCardHeader>
                    <IonCardTitle>Variables (Box)</IonCardTitle>
                  </IonCardHeader>
                  <IonCardContent className="asset-display">
                     <AnimatedSVG src="concepts/common/variables.svg" animation="bounce" />
                  </IonCardContent>
                </IonCard>
              </IonCol>

              <IonCol size="12" sizeMd="6">
                <IonCard className="asset-card">
                  <IonCardHeader>
                    <IonCardTitle>Loops (Race Track)</IonCardTitle>
                  </IonCardHeader>
                  <IonCardContent className="asset-display">
                     <AnimatedSVG src="concepts/common/loops.svg" />
                  </IonCardContent>
                </IonCard>
              </IonCol>

              <IonCol size="12" sizeMd="6">
                <IonCard className="asset-card">
                  <IonCardHeader>
                    <IonCardTitle>Functions (Machine)</IonCardTitle>
                  </IonCardHeader>
                  <IonCardContent className="asset-display">
                     <AnimatedSVG src="concepts/common/functions.svg" />
                  </IonCardContent>
                </IonCard>
              </IonCol>
            </IonRow>
          </IonGrid>

          <h3>In ConceptRenderer Context</h3>
          <div className="concept-list">
            {concepts.map((concept, idx) => (
              <ConceptRenderer key={idx} concept={concept} />
            ))}
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default IllustrationShowcase;
